export enum RefundType {
  FULL_INVOICE = 'Refund full invoice',
  LINE_ITEMS = 'Refund line items',
  TAX_ONLY = 'Refund tax',
}
